import { useEffect, useState, useCallback } from 'react';
import { registerSW } from 'virtual:pwa-register';

export function PwaUpdatePrompt() {
  const [needsRefresh, setNeedsRefresh] = useState(false);
  const [updateServiceWorker, setUpdateServiceWorker] = useState<(() => Promise<void>) | null>(null);

  useEffect(() => {
    const sw = registerSW({
      onNeedRefresh() {
        setNeedsRefresh(true);
      },
      onOfflineReady() {
        // App is ready to work offline
      },
    });
    setUpdateServiceWorker(() => sw);
  }, []);

  const handleReload = useCallback(() => {
    if (updateServiceWorker) {
      updateServiceWorker().then(() => {
        window.location.reload();
      });
    } else {
      window.location.reload();
    }
  }, [updateServiceWorker]);

  if (!needsRefresh) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-brand-600 px-4 py-2 text-center text-sm font-medium text-white shadow-md">
      <span>A new version is available.</span>
      <button
        onClick={handleReload}
        className="ml-3 inline-flex items-center rounded-md bg-white px-3 py-1 text-xs font-semibold text-brand-700 shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600"
      >
        Reload
      </button>
    </div>
  );
}
